import { DASHBOARDS_COLLECTION } from '../constants';

const VISUALISATIONS_COLLECTION = 'visualisations';
const METRIC_DEFINITIONS_COLLECTION = 'metricDefinitions';
const FILTER_DEFINITIONS_COLLECTION = 'filterDefinitions';
const ENTITY_DEFINITIONS_COLLECTION = 'entityDefinitions';
const SAVED_PROGRESSES_COLLECTION = 'savedProgresses';
const TIMELINE_EVENT_COLLECTION = 'timelineEvents';
const DATASETS_COLLECTION = 'datasets'; // mirrored in functions/src/firestorePaths.ts → DATASETS_COLLECTION
const CONTENT_DISTRIBUTIONS_COLLECTION = 'contentDistributions'; // mirrored in functions/src/firestorePaths.ts → CONTENT_DISTRIBUTIONS_COLLECTION
const REASON_CODES_COLLECTION = 'reasonCodes';
const USERS_COLLECTION = 'users';
const GROUPS_COLLECTION = 'groups'; // mirrored in functions/src/firestorePaths.ts → GROUPS_COLLECTION
const LEGACY_SAVED_FILTERS_COLLECTION = 'savedFilters';
const PREVIOUS_UPLOADS_COLLECTION = 'previousUploads';
const DRIVER_BONUS_COLLECTION = 'driverBonus';
const DRIVER_BONUS_REWARDS_COLLECTION = 'driverBonusRewards';
const DRIVER_BONUS_EXCLUSION_GRIDS_CONFIG_COLLECTION =
  'driverBonusExclusionGridsConfig';
const DRIVER_BONUS_TAGS_COLLECTION = 'driverBonusTags';
// Subcollection under driverBonus/{bonusProgramId} — scopes reason codes to
// their program by path rather than a bonusProgramId field + query.
const DRIVER_BONUS_REASON_CODES_SUBCOLLECTION = 'reasonCodes';
// Subcollection under driverBonus/{bonusProgramId} holding a single settings
// doc that controls which rewards are hidden while override mode is active.
const DRIVER_BONUS_OVERRIDE_SETTINGS_SUBCOLLECTION = 'overrideSettings';
const TASKS_COLLECTION = 'tasks';
const LABELS_COLLECTION = 'labels';
const TEXT_CARD_CONTENTS_COLLECTION = 'textCardContents';
const INSIGHTS_CONVERSATIONS_COLLECTION = 'insightsConversations';
const INSIGHTS_FEEDBACK_COLLECTION = 'insightsFeedback'; // mirrored in functions/src/insights/feedback.ts → INSIGHTS_FEEDBACK_COLLECTION
const INSIGHTS_QUERY_LOG_COLLECTION = 'insightsQueryLog'; // mirrored in functions/src/insights/queryLog.ts
// Agent Management knowledge base — mirrored in
// functions/src/insights/agentKb/constants.ts. The same five collections exist
// twice: at the root (the system KB every account's agent reads) and under
// accounts/{accountId} (one customer's own knowledge).
const AGENT_KB_COLLECTION = 'agentKb';
const AGENT_KB_MAIN_DOC_ID = 'main';
const AGENT_KB_ARTEFACTS_COLLECTION = 'artefacts';
const AGENT_KB_REVISIONS_COLLECTION = 'revisions';
const AGENT_KB_VERSIONS_COLLECTION = 'versions';
const AGENT_KB_PINS_COLLECTION = 'pins';
// Evaluation checks. Global checks live at the root; an account's own checks,
// its per-check lastRun and its runs live under accounts/{id}/agentKb/main.
// Mirrored in functions/src/insights/agentEval/constants.ts.
const AGENT_EVAL_CHECKS_COLLECTION = 'agentEvalChecks';
const AGENT_KB_EVAL_CHECKS_COLLECTION = 'evalChecks';
const AGENT_KB_EVAL_HEADS_COLLECTION = 'evalHeads';
const AGENT_KB_EVAL_RUNS_COLLECTION = 'evalRuns';
const MAINTENANCE_MODES_COLLECTION = 'maintenanceModes';
const FIXED_PERIODS_COLLECTION = 'periods';
const DRIVER_BONUS_SETTINGS_COLLECTION = 'driverBonusSettings';
const REPORT_SCHEDULES_COLLECTION = 'reportSchedules'; // mirrored in functions/src/firestorePaths.ts → REPORT_SCHEDULES_COLLECTION
const REPORT_SCHEDULE_RUNS_COLLECTION = 'reportScheduleRuns'; // mirrored in functions/src/firestorePaths.ts → REPORT_SCHEDULE_RUNS_COLLECTION
const RENDER_TOKENS_COLLECTION = 'renderTokens'; // mirrored in functions/src/firestorePaths.ts → RENDER_TOKENS_COLLECTION
const CHART_PALETTES_COLLECTION = 'chartPalettes';
// Per-user UI state that follows a person across accounts (e.g. the Studio
// guide's tour and tips), keyed by their uid
const USER_UI_STATE_COLLECTION = 'userUiState';
export const COPY_CONTENT_RECEIPTS_COLLECTION = 'copyContentReceipts';
export const BONUS_APPS_DOC = 'bonus-apps'; // mirrored in functions/src/firestorePaths.ts → BONUS_APPS_DOC
export const BONUS_APPS_VERSION = 'v1'; // mirrored in functions/src/firestorePaths.ts → BONUS_APPS_VERSION
export const LEGACY_BONUS_APPS_DOC = 'legacy-bonus-apps';
export const LEGACY_BONUS_APPS_VERSION = 'v1';
export const PERFORMANCE_BOARDS_DOC = 'performanceBoards'; // mirrored in functions/src/firestorePaths.ts → PERFORMANCE_BOARDS_DOC
export const PERFORMANCE_BOARDS_VERSION = 'v3'; // mirrored in functions/src/firestorePaths.ts → PERFORMANCE_BOARDS_VERSION
export const PRODUCTS_DOC = 'products'; // mirrored in functions/src/firestorePaths.ts → PRODUCTS_DOC
export const PRODUCTS_VERSION = 'v1'; // mirrored in functions/src/firestorePaths.ts → PRODUCTS_VERSION

const STORE_CONSTANTS = {
  VISUALISATIONS_COLLECTION,
  METRIC_DEFINITIONS_COLLECTION,
  FILTER_DEFINITIONS_COLLECTION,
  ENTITY_DEFINITIONS_COLLECTION,
  TIMELINE_EVENT_COLLECTION,
  DATASETS_COLLECTION,
  DASHBOARDS_COLLECTION,
  SAVED_PROGRESSES_COLLECTION,
  CONTENT_DISTRIBUTIONS_COLLECTION,
  REASON_CODES_COLLECTION,
  USERS_COLLECTION,
  USER_UI_STATE_COLLECTION,
  GROUPS_COLLECTION,
  INSIGHTS_CONVERSATIONS_COLLECTION,
  INSIGHTS_FEEDBACK_COLLECTION,
  INSIGHTS_QUERY_LOG_COLLECTION,
  AGENT_KB_COLLECTION,
  AGENT_KB_MAIN_DOC_ID,
  AGENT_KB_ARTEFACTS_COLLECTION,
  AGENT_KB_REVISIONS_COLLECTION,
  AGENT_KB_VERSIONS_COLLECTION,
  AGENT_KB_PINS_COLLECTION,
  AGENT_EVAL_CHECKS_COLLECTION,
  AGENT_KB_EVAL_CHECKS_COLLECTION,
  AGENT_KB_EVAL_HEADS_COLLECTION,
  AGENT_KB_EVAL_RUNS_COLLECTION,
  LEGACY_SAVED_FILTERS_COLLECTION,
  PREVIOUS_UPLOADS_COLLECTION,
  COPY_CONTENT_RECEIPTS_COLLECTION,
  DRIVER_BONUS_COLLECTION,
  DRIVER_BONUS_REWARDS_COLLECTION,
  TASKS_COLLECTION,
  FIXED_PERIODS_COLLECTION,
  DRIVER_BONUS_EXCLUSION_GRIDS_CONFIG_COLLECTION,
  DRIVER_BONUS_SETTINGS_COLLECTION,
  DRIVER_BONUS_TAGS_COLLECTION,
  DRIVER_BONUS_REASON_CODES_SUBCOLLECTION,
  DRIVER_BONUS_OVERRIDE_SETTINGS_SUBCOLLECTION,
  LABELS_COLLECTION,
  TEXT_CARD_CONTENTS_COLLECTION,
  MAINTENANCE_MODES_COLLECTION,
  REPORT_SCHEDULES_COLLECTION,
  REPORT_SCHEDULE_RUNS_COLLECTION,
  RENDER_TOKENS_COLLECTION,
  CHART_PALETTES_COLLECTION,
};

export default STORE_CONSTANTS;
